export const catEstatusCotizacion = Object.freeze({
    NO_APLICA: 0,
    GENERADA: 1,
    ACEPTADA_CLIENTE: 2,
    ACEPTADA_AGENTE:3,
    CUENTA_ASOCIADA: 4,
    CONTRATO_ENVIADO: 5,
    CONTRATO_ACEPTADO: 6,
    CERRADO_GANADO: 7,
    CONTRATO_RECHAZADO: 8,
    CONTRATO_EXPIRADO: 9,
    RECHAZADA: 10,
    DECLINADA_AGENTE: 11,
    COTIZACION_EXPIRADA: 12,
    PENDIENTE_REVISION: 13,
    DECLINADA_SUPERVISOR: 14
})